import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'ng-sidebar';
import { NouisliderModule } from 'ng2-nouislider';
import { WizardModule } from 'ng2-archwizard';
import { NgUploaderModule } from 'ngx-uploader';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { TooltipModule } from 'ngx-tooltip';
import { Ng2CompleterModule } from 'ng2-completer';
import { FacebookModule } from 'ngx-facebook';
import { AccordionModule, DatepickerModule } from 'ngx-bootstrap';
import { DateTimePickerModule } from 'ng-pick-datetime';
import { MyDatePickerModule } from 'mydatepicker';
import { ToastrModule } from 'ngx-toastr';
import { TooltipDirective } from 'ng2-tooltip-directive/components';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { BootstrapModalModule } from 'ng2-bootstrap-modal';

@NgModule({
  declarations: [
    TooltipDirective,
  ],
  imports: [
    CommonModule,
    PrettyJsonModule,
    AccordionModule.forRoot(),
    DatepickerModule.forRoot(),
    SidebarModule.forRoot(),
    NouisliderModule,
    WizardModule,
    NgUploaderModule,
    TooltipModule,
    Ng2CompleterModule,
    FacebookModule.forRoot(),
    DateTimePickerModule,
    MyDatePickerModule,
    ToastrModule.forRoot(), // ToastrModule added
    CurrencyMaskModule,
    BootstrapModalModule,
  ],
  exports: [
    TooltipDirective,
    PrettyJsonModule,
    AccordionModule,
    DatepickerModule,
    SidebarModule,
    NouisliderModule,
    WizardModule,
    NgUploaderModule,
    TooltipModule,
    Ng2CompleterModule,
    FacebookModule,
    DateTimePickerModule,
    MyDatePickerModule,
    ToastrModule,
    CurrencyMaskModule,
    BootstrapModalModule,
  ],
  providers: [
  ]
})
export class AppComponentPluginModule { }



// WEBPACK FOOTER //
// ./src/app/core/component/plugin/app-component-plugin.module.ts